/*
 * Copyright (C) 2019 - present Marek Kuzora - All Rights Reserved.
 */


export default class
{
  constructor (zone)
  {
    this.zone = zone;
  }


  isExternalBorder (neighbor)
  {
    const neighborZone = neighbor.getZone();

    return !neighborZone || neighborZone.getUserID() !== this.zone.getUserID();
  }


  isGroupBorder (neighbor)
  {
    const neighborZone = neighbor.getZone();

    return neighborZone && neighborZone.getSector().getID() !== this.zone.getSector().getID();
  }


}
